import firebase from 'firebase'
import 'firebase/auth'
import 'firebase/app'

/*var firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_BASEURL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};*/
var firebaseConfig = {
  apiKey: "AIzaSyDowBQDqi5tq0DTGR2IHNb5Nq8oUmNuELk",
  authDomain: "campuscogbg-dashboard.firebaseapp.com",
  databaseURL: "https://campuscogbg-dashboard.firebaseio.com",
  projectId: "campuscogbg-dashboard",
  storageBucket: "campuscogbg-dashboard.appspot.com",
  messagingSenderId: "155466761878",
  appId: "1:155466761878:web:b23d9f0b34b587697364b7"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.auth();

export default {
  firebaseConfig, 
}